export function formatCurrency(value: number): string {
  if (isNaN(value)) return "";

  // Check if the number has decimal places
  const hasDecimals = value % 1 !== 0;

  // If it has decimals, show 2 decimal places, otherwise show no decimals
  return value.toLocaleString(undefined, {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  });
}

export function formatRate(value: number): string {
  if (isNaN(value)) return "";

  // Check if the number has 2 or more decimal places
  const decimalPlaces = (value.toString().split(".")[1] || "").length;
  const hasTwoOrMoreDecimals = decimalPlaces >= 2;

  return value.toLocaleString(undefined, {
    minimumFractionDigits: hasTwoOrMoreDecimals ? 3 : decimalPlaces,
    maximumFractionDigits: hasTwoOrMoreDecimals ? 3 : decimalPlaces,
  });
}
